import $axios from "../../api.js";

const state = () => ({
  data_check: {
    no_pelanggan: "",
    product_id: "",
    biaya_outlet: "0",
  },
  data_payment: {
    invoice: "",
  },
  data_product_selected: {
    pascabayar_category: {
      product_name: "",
    },
  },
});

const mutations = {
  SET_DATA_PRODUCT_SELECTED(state, payload) {
    state.data_product_selected = payload;
  },
  RESET_DATA_CHECK(state) {
    state.data_check = {
      no_pelanggan: "",
      product_id: "",
      biaya_outlet: "0",
    };
  },
  RESET_DATA_PAYMENT(state) {
    state.data_payment = {
      invoice: "",
    };
  },
  RESET_DATA_PRODUCT_SELECTED(state) {
    state.data_product_selected = {
      prabayar_category: {
        product_name: "",
      },
    };
  },
};

const actions = {
  transactionOrder({ state }) {
    return new Promise((resolve, reject) => {
      $axios
        .post("/sender/request-code", state.data_order)
        .then((response) => {
          // console.log(state.sender);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
